import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { MotionConfig } from "framer-motion";
import useLenis from "@/hooks/useLenis";
import { AuthProvider } from "@/context/AuthContext";
import { ConsultationProvider } from "@/context/ConsultationContext";
import { ConsultationDialog } from "@/components/ConsultationDialog";
import { Grain } from "@/components/Grain";
import { Cursor } from "@/components/Cursor";

import Home from "@/pages/Home";
import PillarPage from "@/pages/PillarPage";
import ServicePage from "@/pages/ServicePage";
import LearnPage from "@/pages/LearnPage";
import GuidePage from "@/pages/GuidePage";
import CityPage from "@/pages/CityPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import NotFound from "@/pages/NotFound";

function App() {
  useLenis();
  return (
    <AuthProvider>
      <ConsultationProvider>
        <MotionConfig reducedMotion="user">
        <BrowserRouter>
          <Cursor />
          <Grain />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/build" element={<PillarPage group="BUILD" />} />
            <Route path="/move" element={<PillarPage group="MOVE" />} />
            <Route path="/grow" element={<PillarPage group="GROW" />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/guides/:slug" element={<GuidePage />} />
            <Route path="/cities/:slug" element={<CityPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ConsultationDialog />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
        </MotionConfig>
      </ConsultationProvider>
    </AuthProvider>
  );
}

export default App;
